/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[customSpinner]',
  standalone: true,
})
export class CustomSpinnerDirective implements AfterViewInit {
  @Input() spinnerWidth?: string; // px
  @Input() spinnerHeight?: string; // px
  @Input() spinnerMargin?: string; // CSS margin string

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    // Hide spinner immediately
    this.renderer.setStyle(this.el.nativeElement, 'visibility', 'hidden');

    setTimeout(() => {
      // goa-spinner is a web component
      const shadowRoot = this.el.nativeElement.shadowRoot;
      if (!shadowRoot) return;

      const spinnerRoot =
        shadowRoot.querySelector('div > goa-spinner')?.shadowRoot;
      if (!spinnerRoot) return;

      const svg = spinnerRoot.querySelector('svg');
      if (!svg) return;

      if (this.spinnerWidth) {
        this.renderer.setAttribute(svg, 'width', `${this.spinnerWidth}`);
      }

      if (this.spinnerHeight) {
        this.renderer.setAttribute(svg, 'height', `${this.spinnerHeight}`);
      }

      const spinnerContainer = shadowRoot.querySelector(
        'div[class^="spinner-"]'
      ) as HTMLElement;

      if (!spinnerContainer) return;

      if (spinnerContainer) {
        this.renderer.setStyle(
          spinnerContainer,
          'margin',
          `${this.spinnerMargin}`
        );
      }

      // Show spinner after resizing is complete
      this.renderer.setStyle(this.el.nativeElement, 'visibility', 'visible');
    }, 0);
  }
}
